import {
  Box, Button, Grid, Paper, Table, TableBody, TableCell, TableContainer,
  TableRow, Typography, Card, TableHead, ButtonGroup, FormControlLabel, Checkbox, Divider, FormControl, InputLabel, MenuItem, Select, Stack,
} from '@mui/material'
import { ClassNameMap, withStyles } from '@mui/styles'
import React, { useState } from 'react'
import stylesheet from '../detail-container.stylesheet'
import { PatientService } from '../../../../services/patient.service'
import moment from 'moment'
import { toast } from 'react-toastify'
import Helper from '../../../../utils/helper'
import { useUpdateDataAction } from '../../../../utils/update-details-hook'
import { RootState } from '../../../../redux/store'
import { useSelector } from 'react-redux'
import UploadTestResultComponent from '../diagnosis/upload-test-result.component'

interface IProps {
  input: any
  name: string
  outer: any
  classes: ClassNameMap
}

const TestHistoryComponent: React.FC<IProps> = ({ input, name, outer, classes, }) => {
  const [status, setStatus] = useState('') as any
  const [isLoading, setIsLoading] = useState(false)
  const patientDetail = useSelector((state: RootState) => state.patientDetail.patientDetail)
  const patientService = new PatientService()
  const { updatePatientData } = useUpdateDataAction(patientDetail.id)

  const handleClose = () => {
    setIsLoading(false)
    outer(input.id, 'view')
  }
  const handleSubmit = () => {
    setIsLoading(true)
    input.id && patientService.putDiagnosticTest(input.id, { 'status': status }).then((res: any) => {
      if (res?.data)
        updatePatientData({ isMeasurement: true, isTreatments: true, isConditions: true })
      handleClose()
    }).catch((error: any) => {
      handleClose()
      toast.error(Helper.getError(error), Helper.bottom_center())
    })
  }

  const getStatusHistory = () => {
    return <Box>
      <TableContainer component={Paper}>
        <Table className={classes.table} aria-label="task history table">
          <TableHead>
            <TableRow>
              <TableCell className={classes.tablePtHistory}>
                <Typography className={classes.taskTableHeaderTitle}>{'Date'}</Typography>
              </TableCell>
              <TableCell className={classes.tableHeader}>
                <Typography className={classes.taskTableHeaderTitle}>Name</Typography>
              </TableCell>
              <TableCell className={classes.tableHeader}>
                <Typography className={classes.taskTableHeaderTitle}>Status</Typography>
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody className={classes.historyData}>
            {[...input?.status_history]
              ?.sort((a: any, b: any) => a?.created_on > b?.created_on ? 1 : -1)
              ?.map((row: any, i: any) => (
                <TableRow key={i}>
                  <TableCell className={classes.tablePaddingPT} scope="row" sx={{ width: '28%' }}>
                    <Typography color={'textSecondary'} className={classes.desc}>
                      <small>{moment.unix(row.created_on).format('MMM DD YYYY hh:mm a')}</small>
                    </Typography>
                  </TableCell>
                  <TableCell className={classes.tablePaddingPT} scope="row" sx={{ width: '30%' }}>
                    <Typography color={'textSecondary'} className={classes.desc}>
                      <small>{row.user_name}</small>
                    </Typography>
                  </TableCell>
                  <TableCell className={classes.tablePaddingPT} scope="row" sx={{ width: 'auto' }}>
                    <Typography color={'textSecondary'} className={classes.desc}>
                      <small>{row.status}</small>
                    </Typography>
                  </TableCell>
                </TableRow>
              ))
            }
          </TableBody>
        </Table>
      </TableContainer>
      <Box className={classes.measurementButton} p={0.4}>
        <Grid container xs={12} direction="row" justifyContent="center" alignItems="center">
          <Typography>
            <Button
              onClick={() => outer(input.id, 'view')}
              size="small"
              className={classes.corfirmCancelButtonStyle}
            >
              <strong>Close</strong>
            </Button>
          </Typography>
        </Grid>
      </Box>
    </Box>
  }

  return <Box className={classes.customCard}>
    <Card variant="outlined">
      <Box className={classes.tableHistoryHeader} p={0.1}>
        <Typography className={classes.titleSmall}><strong>{name}</strong>
        </Typography>
      </Box>
      {getStatusHistory()}
    </Card>
  </Box>
}

export default withStyles(stylesheet)(TestHistoryComponent)
